import React from 'react';
import styled from 'styled-components';
import { MemberInfoValue } from '../../shared/component/headless/input/InputBody';
import MoleculeValue from './molecules/MoleculeValue';

type CareerDateRange = 'start' | 'end';
type CareerDateVariant = 'point' | 'period';

interface CareerDateInputProps {
  careerId: string;
  year: string;
  month: string;
  day: string;
  range: CareerDateRange;
  variant: CareerDateVariant;
  prefix?: string;
}

const DATE_FIELDS = {
  start: {
    year: 'startYear',
    month: 'startMonth',
    day: 'startDay',
  },
  end: {
    year: 'endYear',
    month: 'endMonth',
    day: 'endDay',
  },
} as const;

const CareerDateInput: React.FC<CareerDateInputProps> = ({
  careerId,
  year,
  month,
  day,
  range,
  variant,
  prefix,
}) => {
  const fields = DATE_FIELDS[range];

  return (
    <DateInputGroup $variant={variant}>
      {prefix}
      <MoleculeValue
        careerId={careerId}
        value={year}
        targetField={fields.year}
        inputStyle={DateYearInput}
        StyledDiv={DateValue}
        placeholder="yyyy"
      />
      <DateSeparator>/</DateSeparator>
      <MoleculeValue
        careerId={careerId}
        value={month}
        targetField={fields.month}
        inputStyle={DatePartInput}
        StyledDiv={DateValue}
        placeholder="mm"
      />
      <DateSeparator>/</DateSeparator>
      <MoleculeValue
        careerId={careerId}
        value={day}
        targetField={fields.day}
        inputStyle={DatePartInput}
        StyledDiv={DateValue}
        placeholder="dd"
      />
    </DateInputGroup>
  );
};

const DateInputGroup = styled.div<{ $variant: CareerDateVariant }>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 2px 0;
  border-bottom: 1px solid ${({ theme, $variant }) =>
    $variant === 'point'
      ? theme.colors.color_Gray_04
      : theme.colors.color_Gray_03};
  ${({ theme, $variant }) =>
    $variant === 'point' ? theme.typography.Body_04 : ''};
`;

const DateYearInput = styled(MemberInfoValue)`
  width: 4ch;
  flex: 1.6;
  padding: 0;
  border-bottom: none;
  text-align: center;
`;

const DatePartInput = styled(MemberInfoValue)`
  width: 2ch;
  flex: 1;
  padding: 0;
  border-bottom: none;
  text-align: center;
`;

const DateSeparator = styled.span``;

const DateValue = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
`;

export default CareerDateInput;
